import { Icon, toIconsEnum } from 'components/Icons';

import { AnchorLink } from 'components/anchorLink';
import classNames from 'classnames';
import styles from './SportWidgetList.module.scss';

export type SportWidgetListProps = {
  list: Widget[];
  className?: string;
};

export type Widget = {
  id: string;
  url: string;
  iconColor?: string;
};

export const SportWidgetList = ({ list, className }: SportWidgetListProps) => {
  return (
    <ul className={classNames(styles.container, className ?? '')}>
      {list?.map((item: Widget) => (
        <li className={styles.item} key={item.id} suppressHydrationWarning>
          <AnchorLink href={item.url} className={styles.link}>
            <Icon iconId={toIconsEnum(item.id)} className={styles.icon} color={'var(--color-on-bg-primary)'} />
          </AnchorLink>
        </li>
      ))}
    </ul>
  );
};
